import {Device} from '@fantasmagames/core/src/device/Device';
import {CoreDI} from '@fantasmagames/core/src/di/CoreDI';
import {ResourcesLoader, SoundMap, SoundVolumeMap} from '@fantasmagames/core/src/loader/ResourcesLoader';
import {inject, injectable} from 'inversify';
import 'pixi-sound';
import Sound = PIXI.sound.Sound;
import IMediaInstance = PIXI.sound.IMediaInstance;

@injectable()
export class SoundManager {
	public get loader(): ResourcesLoader {
		return this._loader;
	}
	protected _effects: SoundMap = {};

	protected _music: SoundMap = {};

	protected _voices: SoundMap = {};

	protected _volumes: SoundVolumeMap = {};

	@inject(CoreDI.ResourceLoader)
	private _loader: ResourcesLoader;

	constructor() {}

	public init(device: Device): void {
		this.initEffects();
		this.initMusic();
		this.initVoice();
		this.initVolumes();
	}

	public hasEffect(soundID: string): boolean {
		return !!this._effects[soundID];
	}

	public hasMusic(musicID: string): boolean {
		return !!this._music[musicID];
	}

	public hasVoice(voiceID: string): boolean {
		return !!this._voices[voiceID];
	}

	public getEffect(soundID: string): Sound {
		return this._effects[soundID];
	}

	public getMusic(musicID: string): Sound {
		return this._music[musicID];
	}

	public getVoice(voiceID: string): Sound {
		return this._voices[voiceID];
	}

	public getSoundVolume(soundID: string): number {
		return this._volumes[soundID] ? this._volumes[soundID] : 1;
	}

	public getAllPlayingEffects(): IMediaInstance[] {
		return this.getAllPlayingInstancesFromSoundList(this._effects);
	}

	public getAllPlayingVoices(): IMediaInstance[] {
		return this.getAllPlayingInstancesFromSoundList(this._voices);
	}

	public getAllPlayingMusic(): IMediaInstance[] {
		return this.getAllPlayingInstancesFromSoundList(this._music);
	}

	public muteAllSounds(): void {
		for (const key in this._effects) {
			if (this._effects.hasOwnProperty(key)) {
				this._effects[key].muted = true;
			}
		}
	}

	public unmuteAllSounds(): void {
		for (const key in this._effects) {
			if (this._effects.hasOwnProperty(key)) {
				this._effects[key].muted = false;
			}
		}
	}

	public muteAllMusic(): void {
		for (const key in this._music) {
			if (this._music.hasOwnProperty(key)) {
				this._music[key].muted = true;
			}
		}
	}

	public unmuteAllMusic(): void {
		for (const key in this._music) {
			if (this._music.hasOwnProperty(key)) {
				this._music[key].muted = false;
			}
		}
	}

	public muteAllVoice(): void {
		for (const key in this._voices) {
			if (this._voices.hasOwnProperty(key)) {
				this._voices[key].muted = true;
			}
		}
	}

	public unmuteAllVoice(): void {
		for (const key in this._voices) {
			if (this._voices.hasOwnProperty(key)) {
				this._voices[key].muted = false;
			}
		}
	}

	public getSoundLength(id: string): number {
		return this._effects[id].duration;
	}

	public getMusicLength(id: string): number {
		return this._music[id].duration;
	}

	public getVoiceLength(id: string): number {
		return this._voices[id].duration;
	}

	protected initEffects(): void {}

	protected initMusic(): void {}

	protected initVoice(): void {}

	protected initVolumes(): void {}

	protected getAllPlayingInstancesFromSoundList(soundList: SoundMap): IMediaInstance[] {
		const sounds = [];

		for (const sfx in soundList) {
			if (soundList.hasOwnProperty(sfx)) {
				const element = soundList[sfx];
				const instances = element.instances;
				if (instances.length) {
					sounds.push(...instances);
				}
			}
		}

		return sounds;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/sound/SoundManager.ts